module.exports = __webpack_public_path__ + "static/media/startcareer.2d47da23.png";